import React from 'react';

const Footer = () => {  
    return (
        <footer className='max-w-5xl mx-auto flex w-full text-black py-3 px-10 mt-36'>
            <div className='logo ml-auto pl-10'>© Steven Powers</div>
        </footer>           
    )
}

export default Footer;